import React, { createContext, useContext, useState } from "react";

type MapMarker = {
  id: string;
};

type MapState = {
  selectedPoint: L.LatLng | null;
  setSelectedPoint: (point: L.LatLng | null) => void;
  selectedDocument: MapMarker | null;
  setSelectedDocument: (marker: MapMarker | null) => void;
};

const MapContext = createContext<MapState | undefined>(undefined);

export function MapContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [selectedPoint, setSelectedPoint] = useState<L.LatLng | null>(null);
  const [selectedDocument, setSelectedDocument] = useState<MapMarker | null>(
    null
  );

  return (
    <MapContext.Provider
      value={{
        selectedPoint,
        setSelectedPoint,
        selectedDocument,
        setSelectedDocument,
      }}
    >
      {children}
    </MapContext.Provider>
  );
}

export const useMapContext = () => {
  const ctx = useContext(MapContext);
  if (!ctx)
    throw new Error("useMapContext must be used within MapContextProvider");
  return ctx;
};
